// by sudz - 260926 - Deferral Action: Explicit "Later" button on rating modal
import React, { useState } from "react";
import "./ScoreCard.css";
import "./TestScreen.css";

const RateScorecardModal = ({ open, onClose, title = "Rate the Score Card" }) => {
  const [rating, setRating] = useState(0);
  const [ratingDescription, setRatingDescription] = useState("");

  if (!open) return null;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-content rate-scorecard-modal">
        <button
          type="button"
          className="modal-close"
          onClick={onClose}
        >
          ×
        </button>
        <h2 className="modal-title">{title}</h2>

        <div className="rate-stars-row">
          {[1, 2, 3, 4, 5].map((star) => {
            const filled = star <= rating;
            return (
              <button
                key={star}
                type="button"
                className={`rate-star-btn ${filled ? "filled" : ""}`}
                onClick={() => setRating(star)}
                aria-label={`${star} star`}
              >
                <svg width="32" height="32" viewBox="0 0 20 20">
                  <path d="M10 2L12.09 7.26L17.5 7.64L13.18 11.42L14.54 16.77L10 13.97L5.46 16.77L6.82 11.42L2.5 7.64L7.91 7.26L10 2Z"
                    fill={filled ? "#eab308" : "#ffffff"}
                    stroke={filled ? "#eab308" : "#cbd5e1"}
                    strokeWidth="1"
                  />
                </svg>
              </button>
            );
          })}
        </div>

        <label className="rate-description-label" htmlFor="rate-description">
          Description
        </label>
        <textarea
          id="rate-description"
          className="rate-description-textarea"
          placeholder="Share your feedback about this score card..."
          value={ratingDescription}
          onChange={(e) => setRatingDescription(e.target.value)}
        />

        <div className="rate-modal-actions">
          <button
            type="button"
            className="rate-modal-later"
            onClick={() => {
              setRating(0);
              setRatingDescription("");
              onClose();
            }}
          >
            Later
          </button>
          <button
            type="button"
            className="rate-modal-submit"
            disabled={rating === 0}
            onClick={() => {
              console.log("Scorecard rating submitted:", { rating, description: ratingDescription.trim() });
              setRating(0);
              setRatingDescription("");
              onClose();
            }}
          >
            Submit Rating
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateScorecardModal;